'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.organizationSelector = exports.wixInstanceSelector = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

exports.onLoadFullSuccess = onLoadFullSuccess;
exports.default = organizationRootSaga;

var _effects = require('redux-saga/effects');

var _WebInitActions = require('../actions/WebInitActions');

var WebInitActions = _interopRequireWildcard(_WebInitActions);

var _I18nActions = require('../actions/I18nActions');

var I18nActions = _interopRequireWildcard(_I18nActions);

var _OrganizationActions = require('../actions/OrganizationActions');

var OrganizationActions = _interopRequireWildcard(_OrganizationActions);

var _LocationsActions = require('../actions/LocationsActions');

var LocationsActions = _interopRequireWildcard(_LocationsActions);

var _wixrestBi = require('@wix/wixrest-bi');

var _momentTimezone = require('moment-timezone');

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(onLoadFullSuccess),
    _marked2 = /*#__PURE__*/_regenerator2.default.mark(waitForFullSuccess),
    _marked3 = /*#__PURE__*/_regenerator2.default.mark(organizationRootSaga);

function onLoadFullSuccess(sagaParams, action) {
    var payload, full, skipI18nRequestChange, organization, storedOrganization, wixInstance, locations;
    return _regenerator2.default.wrap(function onLoadFullSuccess$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    payload = action.payload;
                    full = payload.full, skipI18nRequestChange = payload.skipI18nRequestChange;

                    if (full) {
                        _context.next = 4;
                        break;
                    }

                    return _context.abrupt('return');

                case 4:
                    organization = full.restaurant || full.chain;
                    _context.next = 7;
                    return (0, _effects.select)(organizationSelector);

                case 7:
                    storedOrganization = _context.sent;

                    if (!(organization && storedOrganization && organization.id === storedOrganization.id && organization.modified === storedOrganization.modified)) {
                        _context.next = 10;
                        break;
                    }

                    return _context.abrupt('return');

                case 10:
                    if (skipI18nRequestChange) {
                        _context.next = 13;
                        break;
                    }

                    _context.next = 13;
                    return (0, _effects.put)(I18nActions.actions.i18nRequestChange({ organizationLocale: organization.locale, countryCode: organization.address.countryCode }));

                case 13:
                    _context.next = 15;
                    return (0, _effects.select)(wixInstanceSelector);

                case 15:
                    wixInstance = _context.sent;


                    if (wixInstance) {
                        _wixrestBi.BI.init({
                            organizationId: organization.id,
                            metasiteId: wixInstance.msid,
                            biToken: wixInstance.biToken,
                            instanceId: wixInstance.instanceId,
                            ownerId: wixInstance.siteOwnerId,
                            roles: wixInstance.permissions || '',
                            useIframeLogger: sagaParams.isIframeTPA
                        });
                    } else {
                        _wixrestBi.BI.init({
                            organizationId: organization.id,
                            metasiteId: ((organization || {}).externalIds || {})['com.wix.metasiteId'] || '5a7be6cc-b73c-45c9-8f3b-a9b6321fc205',
                            useIframeLogger: sagaParams.isIframeTPA
                        });
                    }

                    _momentTimezone2.default.tz.setDefault(organization.timezone);
                    _context.next = 20;
                    return (0, _effects.put)(OrganizationActions.actions.organizationLoad({ organization: organization, isOriginOrg: !!full.isOriginFull }));

                case 20:
                    locations = full.locations;

                    if (!(locations && locations.length)) {
                        _context.next = 24;
                        break;
                    }

                    _context.next = 24;
                    return (0, _effects.put)(LocationsActions.actions.setLocations({ locations: locations }));

                case 24:
                case 'end':
                    return _context.stop();
            }
        }
    }, _marked, this);
}

// ============================================================================
// PRIVATE HELPER METHODS
// ============================================================================
var wixInstanceSelector = exports.wixInstanceSelector = function wixInstanceSelector(state) {
    return state.wixInstance.parsed;
};
var organizationSelector = exports.organizationSelector = function organizationSelector(state) {
    return state.organization.organization;
};

// ============================================================================
// WATCHERS
// ============================================================================

function waitForFullSuccess(sagaParams) {
    return _regenerator2.default.wrap(function waitForFullSuccess$(_context2) {
        while (1) {
            switch (_context2.prev = _context2.next) {
                case 0:
                    _context2.next = 2;
                    return (0, _effects.takeEvery)(WebInitActions.types.LOAD_FULL_SUCCESS, onLoadFullSuccess.bind(null, sagaParams));

                case 2:
                case 'end':
                    return _context2.stop();
            }
        }
    }, _marked2, this);
}

// ============================================================================
// DEFAULT SAGA EXPORT
// ============================================================================

function organizationRootSaga(sagaParams) {
    return _regenerator2.default.wrap(function organizationRootSaga$(_context3) {
        while (1) {
            switch (_context3.prev = _context3.next) {
                case 0:
                    _context3.next = 2;
                    return (0, _effects.all)([(0, _effects.fork)(waitForFullSuccess.bind(null, sagaParams))]);

                case 2:
                case 'end':
                    return _context3.stop();
            }
        }
    }, _marked3, this);
}